export default __webpack_public_path__ + "static/media/edit-icon.51bf4ed3.svg";